import { CustomerSizeCode, CustomerTurnoverCode, Page, QueryBase } from "../../shared/models/models";

export interface Customer {
  id: string;
  createdDate: Date;
  modifiedDate: Date;
  name: string;
  role: Role | null;
  website: string;
  industryCode?: CustomerIndustryCode | null;
  turnoverCode?: CustomerTurnoverCode | null;
  sizeCode?: CustomerSizeCode | null;
  vatId?: string;
  taxId?: string;
  isDisabled: boolean;
}

export interface ChangeCustomer {
  name: string,
  vatId?: string,
  taxId?: string,
  website?: string,
  turnoverCode?: CustomerTurnoverCode | null,
  sizeCode?: CustomerSizeCode | null
}

export interface Role {
  id: string;
  name: string;
}

export interface CustomerTurnover {
  id: number;
  name: string;
}

export interface CustomerSize {
  id: number;
  name: string;
}

export interface AdminCustomersState {
  query: CustomersQuery;
  customers?: Page<Customer>;
  customer?: Customer;
  loading: boolean;
  success?: string;
  error: any;
}

export interface CustomersQuery extends QueryBase<CustomersQueryParameter> {
}

export enum CustomerIndustryCode {
}

export enum CustomersQueryParameter {
  Name = 1,
  CreatedDate = 2,
  ModifiedDate = 3,
  Role = 4,
  Disabled = 5
}